import { action } from 'satcheljs';
import type { ClientItemId } from 'owa-client-ids';

/**
 * Action fired when a conversation reading pane has finished loading
 * @param conversationId The conversation that was loaded
 */
export interface OnReadingPaneLoadedActionMessage {
    conversationId: ClientItemId;
}

export const onReadingPaneLoaded: (
    conversationId: ClientItemId
) => OnReadingPaneLoadedActionMessage = action(
    'onReadingPaneLoaded',
    (conversationId: ClientItemId): OnReadingPaneLoadedActionMessage => ({
        conversationId,
    })
);
